import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { FOCUS_VISIBLE_OUTLINE } from "../../../utils/css-helpers";
import { ChevronDownIcon, CloseIcon, LockIcon } from "../../icons";
import { Spinner } from "../../Spinner";
export const Actions = (props) => {
    const iconSize = props.size === "large" ? "md" : "sm";
    const handleCloseKeyDown = (e) => {
        if (e.code === "Space" || e.code === "Enter" || e.code === "NumpadEnter") {
            props.clearValue();
        }
    };
    return (_jsxs(_Fragment, { children: [props.isClearable &&
                !props.isEmptyValue &&
                !props.isDisabled &&
                !props.isReadonly && (_jsx("span", { onClick: props.clearValue, onKeyDown: handleCloseKeyDown, className: classNames("mx-1 flex items-center", FOCUS_VISIBLE_OUTLINE, !props.isDisabled && "cursor-pointer"), tabIndex: 0, children: _jsx(CloseIcon, { size: iconSize }) })), _jsx("div", { className: classNames("pl-1", props.isClearable &&
                    !props.isDisabled &&
                    !props.isReadonly &&
                    "border-l border-l-border-regular dark:border-l-border-regular"), children: _jsxs("div", { className: "flex items-center h-full", children: [(props.isDisabled || props.isReadonly) && (_jsx(LockIcon, { color: props.isReadonly ? "text-subdued" : "text-disabled", size: iconSize })), !props.isDisabled && props.isLoading && _jsx(Spinner, { size: iconSize }), !props.isDisabled && !props.isReadonly && !props.isLoading && (_jsx(ChevronDownIcon, { size: iconSize }))] }) })] }));
};
//# sourceMappingURL=Actions.js.map